var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    style: {
      position: 'absolute',
      left: 0,
      top: 0
    },
    attrs: {
      "width": _vm.measureToHeightRatio(_vm.desiredHeight),
      "height": _vm.measureToHeightRatio(_vm.desiredHeight),
      "viewBox": "".concat(-_vm.measureToHeightRatio(_vm.desiredHeight) * 0.125, " -").concat(_vm.measureToHeightRatio(_vm.desiredHeight) * 0.125, " ").concat(_vm.measureToHeightRatio(_vm.desiredHeight) * 1.25, " ").concat(_vm.measureToHeightRatio(_vm.desiredHeight) * 1.25),
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "r": _vm.measureToHeightRatio(_vm.desiredHeight) / 2 - _vm.measureToHeightRatio(10),
      "cx": _vm.measureToHeightRatio(_vm.desiredHeight) / 2,
      "cy": _vm.measureToHeightRatio(_vm.desiredHeight) / 2,
      "fill": "transparent",
      "stroke": "#ffffff",
      "stroke-width": _vm.measureToHeightRatio(2),
      "stroke-dasharray": (_vm.measureToHeightRatio(_vm.desiredHeight) / 2 - _vm.measureToHeightRatio(10)) * 2 * Math.PI + 'px',
      "stroke-dashoffset": "0"
    }
  }), _c('circle', {
    attrs: {
      "r": _vm.measureToHeightRatio(_vm.desiredHeight) / 2 - _vm.measureToHeightRatio(10),
      "cx": _vm.measureToHeightRatio(_vm.desiredHeight) / 2,
      "cy": _vm.measureToHeightRatio(_vm.desiredHeight) / 2,
      "stroke": "white",
      "stroke-width": _vm.measureToHeightRatio(15),
      "stroke-linecap": "square",
      "stroke-dashoffset": (_vm.measureToHeightRatio(_vm.desiredHeight) / 2 - _vm.measureToHeightRatio(10)) * 2 * Math.PI - _vm.progress * ((_vm.measureToHeightRatio(_vm.desiredHeight) / 2 - _vm.measureToHeightRatio(10)) * 2 * Math.PI) / 100,
      "fill": "transparent",
      "stroke-dasharray": (_vm.measureToHeightRatio(_vm.desiredHeight) / 2 - _vm.measureToHeightRatio(10)) * 2 * Math.PI + 'px'
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }